module.exports = __webpack_public_path__ + "static/the-lives-of-the-artists-dea742da9ff3dad7b39f7bb1569775ee.jpg";